module.exports = __webpack_public_path__ + "017c339c.png";